import {v4 as uuidv4} from 'uuid';

export default class ContactPersonsModel {
    constructor() {
        this.contactPersons = [];
        this.notificationPhoneNumbers = [];
        this.invoiceEmails = [];
        this.notificationEmails = [];
        this.ebokEmails = '';
        this.contactAddress = '';
        this.useEmail =  '';
        this.usePhone =  '';
        this.email = '';
        this.phone = '';
        this.twoStepAuthChosen = this.useEmail === true ? 'EMAIL' : 'PHONE';
    }

    static assign(from, to) {
        if (from) {
            to.contactPersons = from.contactPersons ? ContactPersonsModel.addUUidToElement(from.contactPersons) : [];
            to.notificationPhoneNumbers = from.notificationPhoneNumbers
                ? ContactPersonsModel.addUUidToElement(from.notificationPhoneNumbers)
                : [];
            to.invoiceEmails = from.invoiceEmails ? ContactPersonsModel.addUUidToElement(from.invoiceEmails) : [];
            to.notificationEmails = from.notificationEmails ? ContactPersonsModel.addUUidToElement(from.notificationEmails) : [];
            to.ebokEmails = from.ebokEmails;
            to.contactAddress = from.contactAddress;
            to.useEmail = from.useEmail;
            to.usePhone = from.usePhone;
            to.email = from.email ? from.email : '';
            to.phone = from.phone ? from.phone : '';
            to.twoStepAuthChosen = from.useEmail === true ? 'EMAIL' : 'PHONE';
        } else {
            to = new ContactPersonsModel();
        }
    }
    static addUUidToElement(list) {
        if (list) {
            list.forEach((element) => (element.uuid = uuidv4()));
        }
        return list;
    }
    static copy(from) {
        const to = new ContactPersonsModel();
        ContactPersonsModel.assign(from, to);
        return to;
    }
}
